import { getDistance } from 'geolib'

export default (fro, to) => getDistance(fro, to)
